/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki
     */
    AppId: number;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

